import { render, staticRenderFns } from "./SurveyList.vue?vue&type=template&id=10c290dc&scoped=true"
import script from "./SurveyList.vue?vue&type=script&lang=js"
export * from "./SurveyList.vue?vue&type=script&lang=js"
import style0 from "./SurveyList.vue?vue&type=style&index=0&id=10c290dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c290dc",
  null
  
)

export default component.exports